module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-75.fac54217.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-75.png
// module id = 3353
// module chunks = 11